module.exports = __webpack_public_path__ + "img/add-products-dark.a05b6bad.svg";